import Datatable from '@laraveldaily/vue2-datatable'
// import {abilitiesPlugin} from '@casl/vue'
// import ability from "./core/plugins/ability";
import EventHub from "./core/plugins/EventHubPlugin/EventHub";
import acl from './core/plugins/acl'
import BackButton from './view/pages/plugins/BackButton'
import VueTypedJs from 'vue-typed-js'
import priceInput from "@/view/pages/pickers/priceInput";


const GlobalComponents = {
    install(Vue) {
        Vue.use(Datatable)
        Vue.use(VueTypedJs)
        Vue.component('price-input',priceInput)
        // Vue.use(abilitiesPlugin, ability)
        Vue.use(EventHub)
        Vue.component('back-button', BackButton)
        Vue.use(acl)
    }
}

export default GlobalComponents
